import { useEffect, type ReactNode } from "react";
import { useParish } from "../lib/parishContext";
import { applyParishTheme } from "../lib/theme";

// Route-scoped boundary that tags the document with the parish's
// own branding (cloud-neutral base + parish-set accent). Reads the
// current parish out of the closest ParishDataProvider via useParish
// and reapplies whenever the accent value changes (e.g., after a
// settings save round-trip).
//
// Pairs with <SacristyTheme>, which the authenticated scheduler
// surfaces use to wear Sacristy AI's own identity.
export default function ParishTheme({ children }: { children: ReactNode }) {
  const { parish } = useParish();
  useEffect(() => {
    applyParishTheme(parish.accent_color);
  }, [parish.accent_color]);
  return <>{children}</>;
}
